const ProgressIndicator = () => {
  return null
}

export default ProgressIndicator
